import { render, staticRenderFns } from "./verify-email.vue?vue&type=template&id=5137e8f4&"
import script from "./verify-email.vue?vue&type=script&lang=js&"
export * from "./verify-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports